<template>
  <div>
    <div class="text-right">
      <v-btn small text to="/blogs" color="blue--text">
        All Blogs <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </div>

    <v-layout wrap>
      <blog-item-component
        v-for="blog in blogs"
        :key="blog.id"
        :blog="blog"
        :edit="nope"
      ></blog-item-component>
    </v-layout>

    <!-- <v-btn @click="increment(10)">tambah</v-btn>
        {{tambah}} -->
  </div>
  <!-- <v-container class="ma-0 pa-0" grid-list-sm>
    </v-container> -->
</template>

<script>
import BlogsItemComponent from "../components/BlogsItemComponent.vue";
import { mapMutations, mapGetters } from "vuex";

export default {
  data: () => ({
    apiDomain: "https://demo-api-vue.sanbercloud.com",
    blogs: [],
    nope: true,
  }),
  components: {
    "blog-item-component": BlogsItemComponent,
  },
  computed: {
    ...mapGetters({
      tambah: "counter/count",
      // tambah nama inisial dari count yang di panggil di store index.js
    }),
  },
  created() {
    this.getBlogs();
  },
  methods: {
    ...mapMutations({
      increment: "counter/increment",
    }),
    getBlogs() {
      const config = {
        method: "get",
        url: this.apiDomain + "/api/v2/blog/random/4",
      };
      this.axios(config)
        .then((response) => {
          let { blogs } = response.data;
          this.blogs = blogs;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>